import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { User, Mail, Building2, Calendar, Hash } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

import { parseUtc } from '../lib/parseUtc';
const PARTNER_API = process.env.REACT_APP_PARTNER_BACKEND_URL || 'http://localhost:8081';

const partnerAxios = axios.create({ baseURL: PARTNER_API });

const PartnerProfile = () => {
  const [partner, setPartner] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('partner_token');
    if (token) {
      partnerAxios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    }
    partnerAxios.get('/api/profile')
      .then(res => setPartner(res.data))
      .catch(() => toast.error('Failed to load profile'));
  }, []);

  if (!partner) {
    return <div className="flex items-center justify-center h-64 text-gray-500">Loading...</div>;
  }

  const fields = [
    { icon: User, label: 'Full Name', value: partner.full_name },
    { icon: Mail, label: 'Email', value: partner.email },
    { icon: Building2, label: 'Company', value: partner.company_name },
    { icon: Hash, label: 'Referral Code', value: partner.referral_code },
    { icon: Calendar, label: 'Member Since', value: parseUtc(partner.created_at).toLocaleDateString() },
  ];

  return (
    <div className="p-6">
      <Card>
        <CardHeader>
          <CardTitle>Partner Profile</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center mb-8">
            <div className="h-16 w-16 rounded-full bg-primary/10 flex items-center justify-center">
              <User className="h-8 w-8 text-primary" />
            </div>
            <div className="ml-4">
              <h3 className="text-xl font-semibold">{partner.full_name}</h3>
              <p className="text-gray-500 dark:text-gray-400">{partner.company_name}</p>
            </div>
          </div>
          <div className="space-y-4">
            {fields.map(({ icon: Icon, label, value }) => (
              <div key={label} className="flex items-center py-3 border-b dark:border-surface-border last:border-0">
                <Icon className="h-5 w-5 text-gray-400 mr-4" />
                <div>
                  <p className="text-sm text-gray-500 dark:text-gray-400">{label}</p>
                  <p className="font-medium">{value}</p>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PartnerProfile;
